import React from 'react';
import './FilterBlock.css';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { spliceList } from '../../../driver';
import brandList from '../../../fakeData/brandList';
import priceList from '../../../fakeData/priceList';
import Checkbox from '@mui/material/Checkbox';

const FilterBlock = ({ range, setRange, brand, setBrand }) => {

    return (
        <div className="d-none d-md-block col-md-3 col-lg-3 col-xl-2 left-side-block">
            <div style={{position: 'sticky', top: '49px'}}>
                <div className="filters-block">
                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                        <Typography variant="h6" component="div" gutterBottom>
                            FILTERS
                        </Typography>
                    </Box>
                </div>
                <hr />
                <div className="filters-block">
                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                        <Typography variant="h6" component="div" gutterBottom>
                            PRICE
                        </Typography>
                    </Box>
                    <FormGroup>
                        {
                            priceList.map((each, index) => (
                                <FormControlLabel key={index}
                                    onChange={
                                        (e) => setRange(
                                            (e.target.checked)
                                                ?
                                                [...range,
                                                { startPrice: each.startPrice, endPrice: each.endPrice, id: index }]
                                                : spliceList(range, index))} control={<Checkbox />} label={`৳${each.startPrice} - ৳${each.endPrice}`} />
                            ))
                        }
                    </FormGroup>
                </div>
                <hr />
                <div className="filters-block">
                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                        <Typography variant="h6" component="div" gutterBottom>
                            BRAND
                        </Typography>
                    </Box>
                    <FormGroup>
                        {
                            brandList.map((each, index) => (
                                <FormControlLabel key={index}
                                    onChange={
                                        (e) => setBrand(
                                            (e.target.checked)
                                                ?
                                                [...brand,
                                                { brandName: each.name, id: index }]
                                                : spliceList(brand, index))}
                                    control={<Checkbox />} label={each.name} />
                            ))
                        }
                    </FormGroup>
                </div>
            </div>
        </div>
    );
}

export default FilterBlock;
